export default __webpack_public_path__ + "static/media/login_video.ff80d5c7.webm";